export const m3l0Solution = `%lang starknet

// Functions can take implicit arguments. You might have already encountered this with
// syscall_ptr: felt* for example.
// do not modify code on this line or above

// TODO: fix the "implicit_sum" signature to make the test pass

func implicit_sum{a, b}() -> (result : felt) {
    return (result=a+b);
}

// do not modify code on this line or below

@external
func test_sum{syscall_ptr : felt*}() {
    let a = 3;
    let b = 5;
    let (sum) = implicit_sum{a=a, b=b}();
    assert sum = 8;

    return ();
}`;
